// extracted by mini-css-extract-plugin
export default {"root":"Expires__root--dppBB","autodelete":"Expires__autodelete--11QDC","inline":"Expires__inline--_YoOB"};